import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title() {
    return 'Proyecto SU-37';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
